import React from 'react';
import Footer from '../components/Footer';

const SMSPolicy = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, padding: '40px 20px', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '8px', color: '#1a1a2e' }}>SMS Policy</h1>
        <p style={{ color: '#666', marginBottom: '40px' }}>
          Effective Date: March 1, 2025 | Last Updated: January 15, 2026
        </p>

        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>1. Overview</h2>
            <p>
              ShowingBooker LLC ("ShowingBooker," "we," "us," or "our") uses SMS (Short Message Service)
              text messaging to facilitate property showing notifications, appointment reminders, and
              compliance-related communications. This SMS Policy explains how we collect, use, and
              manage SMS communications.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>2. Consent to Receive SMS Messages</h2>
            <p>
              By providing your mobile phone number and opting in to SMS notifications, you consent
              to receive text messages from ShowingBooker related to:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Property showing appointment confirmations and reminders</li>
              <li>24/48-hour tenant notification notices (as required by law)</li>
              <li>Showing schedule changes or cancellations</li>
              <li>Compliance-related notifications</li>
              <li>Account verification and security alerts</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>3. Message Frequency</h2>
            <p>
              Message frequency varies based on your use of ShowingBooker services. You may receive:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Showing notifications: Per scheduled showing (typically 1-2 messages per showing)</li>
              <li>Reminders: Up to 2 reminders per scheduled appointment</li>
              <li>Account alerts: As needed for security and verification</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>4. Opting Out</h2>
            <p>
              You may opt out of SMS messages at any time by:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Replying "STOP" to any SMS message from ShowingBooker</li>
              <li>Contacting us at david@codexdeus.com</li>
              <li>Updating your notification preferences in your account settings</li>
            </ul>
            <p style={{ marginTop: '12px' }}>
              <strong>Note:</strong> Opting out of SMS notifications may affect your ability to receive
              time-sensitive showing notifications and may impact legal compliance requirements for
              tenant-occupied property showings.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>5. Message and Data Rates</h2>
            <p>
              Standard message and data rates may apply. ShowingBooker does not charge for SMS
              messages, but your mobile carrier may charge you for each message sent or received.
              Please contact your mobile carrier for details about your text messaging plan.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>6. Privacy and Data Protection</h2>
            <p>
              Your phone number and SMS communications are protected under our Privacy Policy.
              We do not sell, rent, or share your mobile phone number with third parties for
              marketing purposes. Your phone number is used solely for ShowingBooker service
              communications.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>7. Legal Compliance Communications</h2>
            <p>
              For tenant-occupied properties, SMS notifications may be used as part of the legal
              compliance process to provide required notice to tenants. These communications are
              logged and stored as part of your compliance audit trail. Opting out of these
              specific messages may require alternative notification methods.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>8. Supported Carriers</h2>
            <p>
              ShowingBooker SMS services are compatible with most major U.S. mobile carriers,
              including but not limited to AT&T, Verizon, T-Mobile, Sprint, and their affiliates.
              Carriers are not liable for delayed or undelivered messages.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>9. Help and Support</h2>
            <p>
              For help with SMS notifications, reply "HELP" to any message or contact us:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Email: david@codexdeus.com</li>
              <li>Address: 26565 Agoura Road, Suite 200, Calabasas, CA 91302 USA</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>10. Changes to This Policy</h2>
            <p>
              We may update this SMS Policy from time to time. Changes will be posted on this
              page with an updated "Last Updated" date. Continued use of SMS services after
              changes constitutes acceptance of the updated policy.
            </p>
          </section>

          <section style={{ marginBottom: '32px', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>Contact Information</h2>
            <p>
              <strong>ShowingBooker LLC</strong><br />
              26565 Agoura Road, Suite 200<br />
              Calabasas, CA 91302 USA<br />
              Email: david@codexdeus.com
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SMSPolicy;
